import request from '@/util/bpmRequest'

/**
 * 获取列表
 */
export function list(params) {
  return request({
    url: '/procInst/list',
    method: 'post',
    params
  })
}
/**
 * 分页获取列表
 */
export function listPage(params) {
  return request({
    url: '/procInst/listPage',
    method: 'post',
    params
  })
}
/**
 * 创建流程实例
 */
export function createProcInstByKey(data) {
  return request({
    url: '/procInst/createProcInstByKey',
    method: 'post',
    data
  })
}

/**
 * 删除流程定义
 */
export function deleteById(params) {
  return request({
    url: '/procInst/deleteById',
    method: 'post',
    params
  })
}

/**
 * 添加评论
 */
export function addComment(data, procInstId) {
  return request({
    url: '/procInst/addComment',
    headers: procInstId,
    method: 'post',
    data
  })
}
/**撤回评论 */
export function withdrawComment(data) {
  return request({
    url: '/procInst/recallComment',
    method: 'post',
    data
  })
}

// 获取流程详情
export function getProcOAHJStatus(data) {
  return request({
    url: '/procInst/getProcStatus',
    method: 'post',
    data
  })
}

// 分享到会话
export function sendFormMsg(data) {
  return request({
    url: "/procInst/sendFormMsg",
    method: "post",
    data
  });
}

// 获取退回节点
export function processRollbackNode(data) {
  return request({
    url: '/procInst/processRollbackNode',
    method: 'post',
    data
  })
}
